<template>
  <div class="btn-group" :class="{ 'dropup': dropup }">
    <button type="button" class="btn dropdown-toggle" :class="buttonClass"
    @click="dropdown('dropdown')">
      <span class="fa" :class="labelIcon"></span>
      {{ label }} <span class="caret"></span>
    </button>
    <ul class="dropdown-menu" ref="dropdown" :class="{ 'dropdown-menu-right': dropright }">
      <template v-for="(action, i) in actions">
        <li>
          <template v-if="action.labelOnly">
            <a>
              <span class="fa fa-fw" :class="action.icon"></span>
              {{ action.label }}
            </a>
          </template>
          <template v-else>
            <a class="interactive-cursor" @click="$emit('action', action.command)">
              <span class="fa fa-fw" :class="action.icon"></span>
              {{ action.label }}
            </a>
          </template>
        </li>
        <li role="separator" class="divider" v-if="i < actions.length - 1"></li>
      </template>
    </ul>
  </div>
</template>

<script>
import dom from '@/util/dom'
export default {
  name: 'DropdownInput',
  props: {
    dropup: {
      type: Boolean,
      default () {
        return false
      }
    },
    dropright: {
      type: Boolean,
      default () {
        return false
      }
    },
    label: {
      type: String
    },
    labelIcon: {
      type: String
    },
    actions: {
      type: Array
    },
    buttonClass: {
      type: String,
      default () {
        return 'btn-default'
      }
    }
  },
  methods: {
    dropdown (ref) {
      dom(this).dropdown(ref)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/DropdownInput.vue